import { Link } from "react-router";
import Logo from "@/src/components/Logo/Logo";
import React from "react";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";

type NavigationBarLogoProps = {
  clickableLogo?: boolean
};

export default function NavigationBarLogo({ clickableLogo = true }: NavigationBarLogoProps) {
  const { customer } = useCustomer();

  if (clickableLogo) {
    return <Link to={customer ? "/servicewelt" : "/"} aria-label={"Zur Übersicht"}>
      <Logo width={134} height={40} sx={{ display: "block" }}/>
    </Link>
  }

  return <Logo width={134} height={40} />
}
